package com.jingfangpai.medicalRecord.model

import kotlinx.serialization.Serializable

@Serializable
class MedicalRecordAndDiagnosis {
    var medicalRecord:MedicalRecordDetail? = null
    var diagnosis:Array<MedicalRecordDiagnosisDto> = arrayOf();
    var diagnosisSuggestion:Array<MedicalRecordDiagnosisSuggestionDto> = arrayOf();
}